export default `query clinics($search: String, $pageSize: Int, $currentPage: Int, $cart_id: String) {
	clinics(search: $search, pageSize: $pageSize, currentPage: $currentPage, cart_id: $cart_id) {
    items {
      id
      name
      address
      city
      url
      latitude
      longitude
      post_code
      website
    }
	}
}
`;
